import { render, staticRenderFns } from "./NoticePopup.vue?vue&type=template&id=fa1c3a08&scoped=true&"
import script from "./NoticePopup.vue?vue&type=script&lang=js&"
export * from "./NoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./NoticePopup.vue?vue&type=style&index=0&id=fa1c3a08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1c3a08",
  null
  
)

export default component.exports